import type { QuoteData } from '../types/quote.types';

export interface ReloadQuoteCopy {
    title: string;
    message: string;
}

const LIVE_COPY: ReloadQuoteCopy = {
    title: 'This quote has changed',
    message:
        'This quote was changed somewhere else. Reload it to continue with the current version; changes made here since the last save will be discarded.',
};

const COMPLETED_COPY: ReloadQuoteCopy = {
    title: 'This quote is complete',
    message: 'This quote has been completed, so it can no longer be changed. Reload to view it.',
};

const DEAD_COPY: ReloadQuoteCopy = {
    title: 'This quote is no longer live',
    message: 'This quote is no longer live, so it can no longer be changed. Reload to view it.',
};

export const RELOAD_FAILED_MESSAGE = 'The quote could not be loaded. Check your connection and try again.';

export const reloadQuoteCopy = (status: QuoteData['status']): ReloadQuoteCopy => {
    if (status === 'completed') return COMPLETED_COPY;
    if (status === 'dead') return DEAD_COPY;
    return LIVE_COPY;
};
